var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('FilePond',{ref:"pond",attrs:{"name":"file","label-idle":_vm.labelIdle,"allow-multiple":true,"allow-revert":false,"accepted-file-types":_vm.acceptedFileTypes,"oninitfile":_vm.onInitFile,"onprocessfile":_vm.onProcessFile,"onprocessfiles":_vm.onProcessFiles,"instant-upload":true,"server":_vm.serverOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }